module.exports = __webpack_public_path__ + "static/media/bat_head.58f4f7c2.png";